<div class="astrea-home">

    <astrea-banner-welcome
        *ngIf="isBrowser"
    ></astrea-banner-welcome>

    <div class="container p-sm-4 p-2">

        <div *ngIf="recents" id="books" class="mb-6">
            <div class="mb-3">
                <h2>{{ 'navigation.recent' | translate }}</h2>
            </div>
            <div class="products-wrapper">
                <astrea-book-simple
                    *ngFor="let b of recents"
                    [book]="b"
                    class="animated astreaFade"
                ></astrea-book-simple>
            </div>
            <div class="t-center">
                <a routerLink="/recent" class="btn btn-green t-white mt-5" mat-button>
                    {{ 'see_more' | translate }}
                </a>
            </div>
        </div>

        <div id="materias" class="mb-6">
            <div class="mb-3">
                <h2>{{ 'home.title_materia' | translate }}</h2>
            </div>
            <div class="d-flex j-c-between flex-wrap">
                <astrea-materia-card
                    *ngFor="let m of materias"
                    [materia]="m"
                    class="animated astreaFade"
                ></astrea-materia-card>
            </div>
        </div>

        <div *ngIf="books" id="books" class="mb-6">
            <div class="mb-3">
                <h2>{{ 'home.title_highlight' | translate }}</h2>
            </div>
            <div class="products-wrapper">
                <astrea-book-simple
                    *ngFor="let b of books"
                    [book]="b"
                    class="animated astreaFade"
                ></astrea-book-simple>
            </div>
            <div class="t-center">
                <a routerLink="/store" class="btn btn-green t-white mt-5" mat-button>
                    {{ 'home.see_more_books' | translate }}
                </a>
            </div>
        </div>

        <div *ngIf="isBrowser" id="clients" class="mb-6">
            <div class="mb-3">
                <h2>{{ 'home.clients' | translate }}</h2>
            </div>
            <div>
                <astrea-clients></astrea-clients>
            </div>
            <br>
        </div>

        <div id="promotions" class="mb-6">
            <astrea-promotions></astrea-promotions>
        </div>

    </div>
</div>
